/**
 * ErrorBoundary Component
 */

// import { linkWithCurrentQueryString } from '../../../../utils/router';
import './styles.scss';

import * as React from 'react';
// import * as BEM from 'react-bem-helper';

import { connect } from 'react-redux';
import { pushNotification } from '../../../../redux/actions/notifications';
// import Button from '../../../atoms/buttons/Button';
// import { IconClear, IconWarningLarge } from '../../../atoms/images/Icon';
// import { DiscoverPagePath } from '../../../pages/browse/Discover';

interface IOwnState {
  hasError: boolean;
}

// const classes = new BEM('error-boundary');

class ErrorBoundary extends React.Component<IDispatchProps, IOwnState> {
  constructor(props) {
    super(props);

    this.state = {
      hasError: false,
    };
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true });
  }

  componentDidUpdate(_, prevState: IOwnState) {
    if (this.state.hasError && !prevState.hasError) {
      this.props.dispatch(pushNotification({
        // tslint:disable-next-line:max-line-length
        message: 'Oops! Something went wrong. If the error persists, please reload the page.',
        state: 'error',
        autoDismiss: false,
      }));
    }
  }

  render() {
    // if (this.state.hasError) {
    //   return (
    //     <div {...classes()}>
    //       <IconWarningLarge {...classes('icon-error')} />
    //       <h1 {...classes('title')}>
    //         <span>Keep</span>
    //         <span>Calm</span>
    //         <small>And</small>
    //         <span>Refresh</span>
    //         <span>This Page</span>
    //       </h1>
    //       <Button
    //         hyperLinkProps={{
    //           href: linkWithCurrentQueryString(DiscoverPagePath),
    //         }}
    //         wrapperComponent="a"
    //         label="Refresh"
    //         size="large"
    //         colorScheme="white"
    //         variant="pill"
    //         icon={<IconClear style={{ transform: 'scaleX(-1) translateY(-50%)' }} />}
    //         withShadow
    //       />
    //     </div>
    //   );
    // }
    return this.props.children;
  }
}

const ConnectedErrorBoundary = connect()(ErrorBoundary);

export default ConnectedErrorBoundary;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/organisms/global/ErrorBoundary/index.tsx